import { userService } from '_services';
import { session } from '_helpers';
import { ACTIONS_USER } from '_constants/user.constants';
import alertActions from './alert.actions';

export const receiveUsers = (users) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < users.length; i++) {
    byIdObjectToDispatch[users[i].userID] = users[i];
  }

  return {
    type: ACTIONS_USER.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteUser = (userId) => ({
  type: ACTIONS_USER.DELETE,
  byId: { [userId]: null }
});

const getUsers = (accountID) => async (dispatch) => {
  try {
    const resp = await userService.getAll(accountID);
    if (resp?.[0]?.userID) {
      dispatch(receiveUsers(resp));
      return resp;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error('Error retrieving users.'));
  }
  return null;
};

const getUser = (userID) => async (dispatch) => {
  try {
    const resp = await userService.getById(userID);
    if (resp?.userID) {
      dispatch(receiveUsers([ resp ]));
      return resp;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error(`Error retrieving user #${userID}.`));
  }
  return null;
};

const addUser = (user) => async (dispatch) => {
  try {
    const resp = await userService.create(user);
    if (resp?.userID) {
      dispatch(receiveUsers([ resp ]));
      return resp;
    }
  } catch (e) {
    console.error(e);
    session.checkSession(e);
    dispatch(alertActions.error(e.message));
  }
  return null;
};

const updUser = (user) => async (dispatch) => {
  try {
    const resp = await userService.update(user);
    if (resp?.userID) {
      dispatch(receiveUsers([ resp ]));
      return resp;
    }
  } catch (e) {
    console.error(e);
    session.checkSession(e);
    dispatch(alertActions.error(e.message));
  }
  return null;
};

const delUser = (userID) => async (dispatch) => {
  try {
    const resp = await userService.delete(userID);
    if (resp?.userID) {
      dispatch(deleteUser(resp.userID));
      return resp;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error(`Error removing user #${userID}.`));
  }
  return null;
};

const userActions = {
  getUsers,
  getUser,
  addUser,
  updUser,
  delUser
};

export default userActions;
